import React from "react";
import { Table, TableHead, TableRow, TableCell, makeStyles, TablePagination, TableSortLabel, } from "@material-ui/core";
import { TEXT_COLOR_1, WHITE, TEXT_COLOR_LIGHT, } from "../../../../../theme/colors";
var useStyles = makeStyles(function (theme) { return ({
    table: {
        marginTop: theme.spacing(3),
        borderCollapse: "separate",
        borderSpacing: "0 3px",
        "& thead th": {
            fontWeight: "500",
            color: theme.palette.secondary.main,
            backgroundColor: "transparent",
            fontSize: "12px",
            textAlign: "center",
            border: "none",
        },
        "& tbody td": {
            fontWeight: "300",
            fontStyle: "normal",
            fontweight: "normal",
            fontSize: "10px",
            color: "#404268",
            textAlign: "center",
            border: "none",
            "&:nth-of-type(1)": {
                fontWeight: 500,
                fontSize: "12px",
                color: "#2D2D2D",
            },
        },
        "& tbody tr:hover": {
            backgroundColor: "#fffbf2",
            cursor: "pointer",
        },
    },
    pagination: {
        width: "100%",
        backgroundColor: WHITE,
        marginTop: 25,
        "& .MuiTablePagination-spacer": {
            display: "none",
        },
        "& .MuiTablePagination-toolbar": {
            padding: 0,
            margin: 0,
        },
        "& .MuiTablePagination-actions": {
            flex: 1,
            textAlign: "right",
        },
        "& .MuiTablePagination-caption": {
            paddingLeft: "16px",
            fontSize: 12,
            fontWeight: 500,
            color: TEXT_COLOR_1,
        },
        "& .MuiTablePagination-input": {
            color: TEXT_COLOR_LIGHT,
            "& svg": {
                color: TEXT_COLOR_LIGHT,
            },
        },
    },
}); });
var useTable = function (_a) {
    var data = _a.data, columns = _a.columns, collapsibleRow = _a.collapsibleRow, handleChangePage = _a.handleChangePage, handleChangeRowsPerPage = _a.handleChangeRowsPerPage, handleSortRequest = _a.handleSortRequest;
    var classes = useStyles();
    var rowsPerPageOptions = data.rowsPerPageOptions, recordsCount = data.recordsCount, rowsPerPage = data.rowsPerPage, page = data.page, sortBy = data.sortBy, sortDirection = data.sortDirection;
    var TblContainer = function (props) { return (React.createElement(Table, { size: "small", className: classes.table }, props.children)); };
    var TblHead = function () {
        return (React.createElement(TableHead, null,
            React.createElement(TableRow, null, columns &&
                columns.length > 0 &&
                columns.map(function (headCell) {
                    return (headCell.id != "id" || collapsibleRow) && (React.createElement(TableCell, { key: headCell.id, align: headCell.id === "actions" ? "right" : "left", sortDirection: sortBy === headCell.id ? sortDirection : false }, headCell.disableSorting ? (headCell.label) : (React.createElement(TableSortLabel, { active: sortBy === headCell.id, direction: sortBy === headCell.id ? sortDirection : "asc", onClick: function () {
                            handleSortRequest
                                ? handleSortRequest(headCell.id)
                                : console.log("sorting");
                        } }, headCell.label))));
                }))));
    };
    var TblPagination = function () { return (React.createElement(TablePagination, { className: classes.pagination, component: "div", page: page ? page - 1 : 1, rowsPerPageOptions: rowsPerPageOptions, rowsPerPage: rowsPerPage ? rowsPerPage : 10, count: recordsCount ? recordsCount : 0, onChangePage: handleChangePage ? handleChangePage : function () { return console.log("page changed"); }, onChangeRowsPerPage: handleChangeRowsPerPage })); };
    return {
        TblContainer: TblContainer,
        TblHead: TblHead,
        TblPagination: TblPagination,
    };
};
export default useTable;
//# sourceMappingURL=UseTable.js.map